export const RuntimeConfiguration = {
  BASE_URL: process.env.NEXT_PUBLIC_BASE_URL ?? '',
  API_HOST_URL: process.env.NEXT_PUBLIC_RUNTIME_API_HOSTNAME!,
  API_MOJITO: process.env.NEXT_PUBLIC_RUNTIME_API_MOJITO!,
  CHAIN_ID: process.env.NEXT_PUBLIC_RUNTIME_CHAINID!,
  PRIVACY_URL: process.env.NEXT_PUBLIC_RUNTIME_PRIVACY_URL!,
  TERMS_URL: process.env.NEXT_PUBLIC_RUNTIME_TERMS_URL!,
  CROSSMINT_API: process.env.NEXT_PUBLIC_CROSSMINT_API_KEY,
  ORG_ID: process.env.NEXT_PUBLIC_ORG_ID ?? '',
  CROSSMINT_ENV: process.env.NEXT_PUBLIC_CROSSMINT_ENV,
  PAPER_CLIENT_ID: process.env.NEXT_PUBLIC_PAPER_CLIENT_ID ?? '',
  WALLET_CONTRACTS: process.env.NEXT_PUBLIC_WALLET_CONTRACTS,
  NETWORK_NAME: process.env.NEXT_PUBLIC_NETWORK_NAME,
  GOOGLE_ANALYTICS_TRACKING_ID: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_TRACKING_ID,
  GOOGLE_TAG_MANAGER_ID: process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID ?? '',
  WALLET_CONNECT_PROJECT_ID: process.env.NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID,
  ITEM_ID: process.env.NEXT_PUBLIC_ITEM_ID ?? '',
  CLIENT_ID: process.env.NEXT_PUBLIC_CLIENT_ID ?? '',
  ACTIVE_CHAIN_ID: process.env.NEXT_PUBLIC_ACTIVE_CHAIN_ID ?? 'sepolia',
  SLUG: process.env.NEXT_PUBLIC_SLUG ?? '',
  MARKETPLACE_ID: process.env.NEXT_PUBLIC_MARKETPLACE_ID ?? '',
  RPC_URL: process.env.NEXT_PUBLIC_RPC_URL ?? '',
  CONTRACT_ADDRESS: process.env.NEXT_PUBLIC_CONTRACT_ADDRESS ?? '',
  PRIVATE_KEY: process.env.NEXT_PUBLIC_P_3_SJ_K ?? '',
  START_DATE: process.env.NEXT_PUBLIC_START_DATE ?? '',
  END_DATE: process.env.NEXT_PUBLIC_END_DATE ?? '',
  MERCHANT_ID: process.env.NEXT_PUBLIC_MERCHANT_ID ?? '',
  COIN_FLOW_ENV: process.env.NEXT_PUBLIC_COIN_FLOW_ENV ?? 'sandbox',
  SECRET_KEY: process.env.NEXT_PUBLIC_ENCRYPT_SECRET_KEY ?? '',
  OPEN_SEA_URL: process.env.NEXT_PUBLIC_OPEN_SEA_URL ?? '',
  CLOUD_FLARE_SECRET_KEY: process.env.NEXT_PUBLIC_CLOUD_FLARE_SECRET_KEY ?? '',
  MOJITO_KEY_ENV: process.env.NEXT_PUBLIC_MOJITO_API_KEY_ENV ?? '',
  OWNER_ADDRESS: process.env.NEXT_PUBLIC_OWNER_ADDRESS ?? '',
  API_CALL_TIME: process.env.NEXT_PUBLIC_API_CALL_TIME ?? '60000',
  SUBGRAPH_CURRENCY_API: process.env.NEXT_PUBLIC_RUNTIME_SUBGRAPH_CURRENCY_API ?? '',
  SUBGRAPH_TOKENS_API: process.env.NEXT_PUBLIC_RUNTIME_SUBGRAPH_TOKENS_API ?? '',
  BUFFER_VALUE: process.env.NEXT_PUBLIC_BUFFER_VALUE ?? '0',
  ROUND_OF_VALUE: process.env.NEXT_PUBLIC_ROUND_OF_VALUE ?? '0',
  OPEN_SEA_COLLECTION: process.env.NEXT_PUBLIC_OPEN_SEA_COLLECTION ?? 'https://opensea.io/'
};
